export const MB_FORMAT = 'MB';

export const MEGABYTES = 1048576;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/MemoryAllocationInput/constants.js